import React, {Component} from 'react';
import {connect} from 'react-redux';
import Loading from '../../apa/components/Loading';

@connect(
    state => ({
        auth: state.apa
    })
)
export default class O365Auth extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            authCode: props.code
        }
    }

    componentDidMount() {
    }

    render() {
        if (this.state.isLoading) {
            return <Loading/>
        } else {
            return <p>Success</p>
        }
    }

}
